import axios from "axios";
import router from '@/router/router'
import { redirectToLogin } from '@/services/authRedirect'

export function createRepository(baseURL, setup = null) {
    const base_url = '/api' + baseURL
    const instance = axios.create({
        baseURL: base_url
    })

    // Global response interceptor
    instance.interceptors.response.use(
        response => response,
        async error => {
            if (error.response?.status === 401) {
                await redirectToLogin(router)
            }

            return Promise.reject(error)
        }
    )

    // Custom interceptor
    if (setup) {
        setup(instance)
    }

    return instance
}